var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H34C38.4183 0 42 3.58172 42 8V31C42 35.4183 38.4183 39 34 39H0V0Z",
  fill: "#E4F3FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8611 5.5C10.036 5.5 9.24467 5.82778 8.66122 6.41122C8.07778 6.99467 7.75 7.78599 7.75 8.61111V30.3889C7.75 31.214 8.07778 32.0053 8.66122 32.5888C9.24467 33.1722 10.036 33.5 10.8611 33.5H32.6389C33.464 33.5 34.2553 33.1722 34.8388 32.5888C35.4222 32.0053 35.75 31.214 35.75 30.3889V8.61111C35.75 7.78599 35.4222 6.99467 34.8388 6.41122C34.2553 5.82778 33.464 5.5 32.6389 5.5H10.8611ZM23.3056 8.61111H32.6389V30.3889H23.3056V8.61111ZM20.1944 8.61111H10.8611V13.2778H20.1944V8.61111ZM20.1944 16.3889H10.8611V22.6111H20.1944V16.3889ZM20.1944 25.7222H10.8611V30.3889H20.1944V25.7222Z",
  fill: "#00538F"
});

function SvgMingcuteLayoutBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteLayoutBlue);
export default __webpack_public_path__ + "static/media/mingcute_layout_blue.de3d84ea.svg";
export { ForwardRef as ReactComponent };